import Player from './player.js';

export default class HumanPlayer extends Player {
  constructor() {
    super('Human');
  }
}
